import { Plus } from 'lucide-react'
import { useState } from 'react'
import { Button } from 'app/components/ui/button'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from 'app/components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from 'app/components/ui/popover'

type InsurancePickerProps = {
  insurances: string[]
  onAdd: (insuranceName: string) => void
}

/** Searchable "Add Insurance" picker; opens below the button and flips up only when there is no room. */
export function InsurancePicker({ insurances, onAdd }: InsurancePickerProps) {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="secondary" size="sm">
          <Plus />
          Add Insurance
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" side="bottom" className="w-md max-w-(--radix-popper-available-width) p-0">
        <Command>
          <CommandInput placeholder="Search insurances..." />
          <CommandList className="max-h-72">
            <CommandEmpty>No insurances found</CommandEmpty>
            <CommandGroup>
              {insurances.map((name) => (
                <CommandItem
                  key={name}
                  value={name}
                  onSelect={() => {
                    onAdd(name)
                    setOpen(false)
                  }}
                >
                  {name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
